import { Combinator } from 'modules/queryBuilder/types';

export enum DQBSearchVariant {
  Query = 'query',
  Criteria = 'criteria',
  Requirement = 'requirement',
}

type DQBSearchVariantValue = {
  labels: Record<Combinator, string>;
  combinators: Combinator[];
};

export type DQBSearchVariantMap = Record<DQBSearchVariant, DQBSearchVariantValue>;
